import React, { useMemo, useState } from "react";
import { Card, Paper } from "@mui/material";
import { RawJsonEditor } from "./RawJsonEditor";
import { TreeNodeIndent } from "./TreeNodeIndent";
import { PathInfo, usePathContext } from "./PathInfo";
import { GamePieceHeader } from "./GamePieceHeader";
import { GamePieceFooter } from "./GamePieceFooter";

interface GamePieceProps {
  gamePieceName: string;
  rawValue: string;
  uniqueKey: string;
}

const isAlwaysRawNames = ["__defaultEditButtons"];

export function GamePiece(props: GamePieceProps) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isRaw, setIsRaw] = useState(false);
  const [gamePieceName, setGamePieceName] = useState(props.gamePieceName);

  const isAlwaysRaw = isAlwaysRawNames.includes(props.gamePieceName);

  const gamePieceData = useMemo(() => {
    return JSON.parse(props.rawValue);
  }, [props.rawValue]);

  const { path } = usePathContext();

  const pathToThisGamePiece = useMemo(() => {
    return path.concat([props.gamePieceName]);
  }, [path, props.gamePieceName]);

  const memoChild = useMemo(() => {
    return <TreeNodeIndent depth={1} data={gamePieceData} path={pathToThisGamePiece} />;
  }, [pathToThisGamePiece, gamePieceData]);

  return (
    <Card elevation={10} className={gamePieceName === "root" ? "root-game-piece" : ""}>
      <PathInfo key={props.uniqueKey} name={gamePieceName}>
        <GamePieceHeader
          setIsCollapsed={setIsCollapsed}
          gamePieceName={props.gamePieceName}
          isCollapsed={isCollapsed}
          isRaw={isRaw || isAlwaysRaw}
          setIsRaw={setIsRaw}
          isAlwaysRaw={isAlwaysRaw}
        />
        {!isCollapsed && !isRaw && !isAlwaysRaw && memoChild}
        {(isRaw || isAlwaysRaw) && (
          <RawJsonEditor rawValue={props.rawValue} path={path} gamePieceName={props.gamePieceName} />
        )}
        <GamePieceFooter gamePieceName={gamePieceName} data={gamePieceData} />
      </PathInfo>
    </Card>
  );
}
